export default __webpack_public_path__ + "static/media/Samiksha_Bhokare.c495b952.jpg";